<template>
  <div class="about-taiku">
    <!-- Banner图片 -->
    <div class="about-banner">
      <img class="about-banner-img" src="@/assets/img/关于我们.png" alt="关于我们主图" loading="eager" />
    </div>

    <!-- 公司简介 -->
    <div class="tk-section tk-intro">
      <div class="tk-intro-title">关于我们</div>
      <div class="tk-intro-sub">About Us</div>
      <div class="tk-intro-desc">
        <p>江西辐氨生物技术有限公司，是一家致力于多肽合成研究及多肽定制合成的高新技术企业。</p>
        <p>公司专注于多肽合成技术的研究与开发，为国内外科研机构、制药企业和生物技术公司提供高质量的多肽产品及专业的多肽定制合成服务。</p>
        <p>核心团队具有国内外一流化学行业背景和丰富的研发、管理经验，致力于向国内外相关企业和科研机构提供高品质的多肽产品。</p>
      </div>
    </div>

    <!-- 发展历程 -->
    <div class="tk-section tk-history">
      <div class="tk-intro-title">公司历程</div>
      <div class="tk-intro-sub">Development History</div>
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in historyList"
          :key="index"
          :timestamp="item.year"
          placement="top"
        >
          <el-card>
            <h4>{{ item.title }}</h4>
            <p>{{ item.description }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>

    <!-- 核心优势 -->
    <div class="tk-section tk-advantage">
      <div class="tk-intro-title">核心优势</div>
      <div class="tk-intro-sub">Core Advantages</div>
      <el-row :gutter="20" class="tk-advantage-row">
        <el-col :span="6" v-for="item in advantageList" :key="item.title">
          <div class="tk-adv-card">
            <img :src="item.icon" class="tk-adv-icon" />
            <div class="tk-adv-title">{{ item.title }}</div>
            <div class="tk-adv-desc">{{ item.desc }}</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 企业文化/愿景 -->
    <div class="tk-section tk-culture">
      <el-row :gutter="30">
        <el-col :span="12">
          <div class="culture-item">
            <div class="culture-title">企业愿景</div>
            <div class="culture-sub">Vision</div>
            <p class="culture-desc">成为全球领先的多肽合成技术和服务提供商，为生命科学研究和新药研发提供强有力的技术支撑。</p>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="culture-item">
            <div class="culture-title">企业使命</div>
            <div class="culture-sub">Mission</div>
            <p class="culture-desc">以科技创新为驱动，为客户提供优质的多肽产品和服务，助力生命科学研究和新药研发事业的发展。</p>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 联系方式 -->
    <div class="tk-section tk-contact">
      <div class="tk-intro-title">联系我们</div>
      <div class="tk-intro-sub">Contact Us</div>
      <el-row :gutter="30">
        <el-col :span="8" v-for="item in contactList" :key="item.type">
          <div class="contact-item">
            <i :class="item.icon" class="contact-icon"></i>
            <div class="contact-title">{{ item.type }}</div>
            <div class="contact-content">{{ item.content }}</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 底部信息 -->
    <div class="tk-footer">
      <div>电话：15002819872&nbsp; 邮箱：15002819872@163.com&nbsp; 地址：江西省赣州市章贡区长征大道12号</div>
      <div>备案号: <a href="https://beian.miit.gov.cn/#/Integrated/index">赣ICP备2026004521号-1</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      historyList: [
        {

          title: '公司成立',
          description: '公司正式成立，专注于多肽合成技术的研发与应用'
        },
        {

          title: '技术突破',
          description: '在多肽合成技术领域取得重要突破，建立完善的研发体系'
        },
        {

          title: '规模扩展',
          description: '扩大生产规模，引进先进设备，提升产能和质量'
        },
        {

          title: '持续发展',
          description: '持续技术创新，拓展国际市场，为客户提供更优质的服务'
        }
      ],
      advantageList: [
        {
          icon: require('@/assets/img/7nian.png'),
          title: '技术积累',
          desc: '3年+多肽合成技术积累，经验丰富'
        },
        {
          icon: require('@/assets/img/3000.png'),
          title: '产品丰富',
          desc: '3000+常备目录肽现货，种类齐全'
        },
        {
          icon: require('@/assets/img/customer.png'),
          title: '客户认可',
          desc: '98%服务客户满意度，品质保证'
        },
        {
          icon: require('@/assets/img/order.png'),
          title: '稳定合作',
          desc: '80%业务来源老客户，信任可靠'
        }
      ],
      contactList: [
        {
          type: '联系电话',
          icon: 'el-icon-phone',
          content: '15002819872'
        },
        {
          type: '电子邮箱',
          icon: 'el-icon-message',
          content: '15002819872@163.com'

        },
        {
          type: '公司地址',
          icon: 'el-icon-location',
          content: '江西省赣州市章贡区长征大道12号'
        }
      ]
    }
  }
}
</script>
<style scoped>
.about-taiku {
  background: #f5f7fa;
  min-height: 100vh;
}
.about-banner {
  margin-top: 8px;
  width: 100%;
  overflow: hidden;
}
.about-banner-img {
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: cover;
  display: block;
}
.tk-section {
  max-width: 1200px;
  margin: 30px auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 30px 30px 10px 30px;
}
.tk-intro-title {
  font-size: 28px;
  color: #0e3fa5;
  text-align: center;
  font-weight: bold;
  margin-bottom: 10px;
}
.tk-intro-sub {
  font-size: 18px;
  color: #888;
  text-align: center;
  margin-bottom: 20px;
}
.tk-intro-desc {
  color: #333;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.8;
}
.tk-intro-desc p {
  margin: 10px 0;
  font-size: 16px;
}
.tk-history {
  margin-top: 30px;
}
.tk-advantage {
  margin-top: 30px;
}
.tk-advantage-row {
  margin-top: 30px;
}
.tk-adv-card {
  padding: 20px 10px;
  text-align: center;
  transition: transform 0.3s;
}
.tk-adv-card:hover {
  transform: translateY(-5px);
}
.tk-adv-icon {
  height: 70px;
  margin-bottom: 15px;
}
.tk-adv-title {
  font-size: 18px;
  color: #0e3fa5;
  font-weight: bold;
  margin-bottom: 10px;
}
.tk-adv-desc {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}
.tk-culture {
  margin-top: 30px;
}
.culture-item {
  padding: 20px;
}
.culture-title {
  font-size: 22px;
  color: #0e3fa5;
  font-weight: bold;
  margin-bottom: 5px;
}
.culture-sub {
  font-size: 16px;
  color: #888;
  margin-bottom: 15px;
}
.culture-desc {
  color: #333;
  font-size: 15px;
  line-height: 1.8;
  text-align: justify;
}
.tk-contact {
  margin-top: 30px;
}
.contact-item {
  text-align: center;
  padding: 20px 10px;
}
.contact-icon {
  font-size: 40px;
  color: #0e3fa5;
  margin-bottom: 15px;
}
.contact-title {
  font-size: 18px;
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;
}
.contact-content {
  color: #666;
  font-size: 15px;
  line-height: 1.6;
}
.tk-footer {
  background: #2f2f2f;
  color: #fff;
  text-align: center;
  padding: 30px 0 10px 0;
  margin-top: 40px;
}
.tk-footer div {
  margin: 5px 0;
  font-size: 14px;
}
.tk-footer a {
  color: #fff;
  text-decoration: none;
}
@media (max-width: 768px) {
  .about-banner-img {
    max-height: 250px;
    object-fit: contain;
  }
  .tk-section {
    margin: 15px 8px;
    padding: 20px 15px;
  }
  .tk-intro-title {
    font-size: 22px;
  }
  .tk-intro-sub {
    font-size: 14px;
  }
  .tk-intro-desc p {
    font-size: 14px;
  }
  .tk-advantage-row {
    margin-top: 15px;
  }
  .tk-adv-card {
    padding: 15px 5px;
    margin-bottom: 15px;
  }
  .tk-adv-icon {
    height: 50px;
  }
  .tk-adv-title {
    font-size: 16px;
  }
  .tk-adv-desc {
    font-size: 13px;
  }
  .tk-culture {
    margin-top: 20px;
  }
  .culture-item {
    padding: 15px;
    margin-bottom: 15px;
  }
  .culture-title {
    font-size: 18px;
  }
  .culture-sub {
    font-size: 14px;
  }
  .culture-desc {
    font-size: 14px;
  }
  .tk-contact {
    margin-top: 20px;
  }
  .contact-item {
    padding: 15px 5px;
    margin-bottom: 15px;
  }
  .contact-icon {
    font-size: 30px;
  }
  .contact-title {
    font-size: 16px;
  }
  .contact-content {
    font-size: 13px;
  }
  .tk-footer {
    padding: 20px 10px 10px 10px;
    margin-top: 20px;
    font-size: 12px;
    line-height: 1.6;
  }
  .tk-footer div {
    word-break: break-all;
    padding: 0 5px;
  }
  /* 响应式 el-row/el-col 卡片区块 */
  .el-row {
    display: flex;
    flex-wrap: wrap;
  }
  .el-col {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 4px;
  }
  .el-col > div, .el-card {
    width: 100% !important;
    box-sizing: border-box;
  }
}
</style>

